import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundary";
import Providers from "Providers";
import { KeycloakProvider } from "./KeycloakProvider";

import "./index.scss";
import "./i18n";

// Keep React in scope for environments using classic JSX runtime.
void React;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <BrowserRouter>
      <KeycloakProvider>
        <Providers>
          <App />
        </Providers>
      </KeycloakProvider>
    </BrowserRouter>
  </ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();

